{
  "pt": {
    "datatable": {
      "actions": {
        "bulk_action": "Ação em massa",
        "bulk_edit": "Editar em massa",
        "clear_filters": "Limpar filtros",
        "collapse_all": "Recolher tudo",
        "deselect_all": "Desmarcar tudo",
        "expand_all": "Expandir tudo",
        "select_all": "Selecionar tudo"
      },
      "import": {
        "title": "Importar",
        "success": "Ficheiro importado com sucesso",
        "errors_title": "Falha na importação",
        "errors_description": "A importação foi cancelada porque {count} linha(s) continham erros. Nenhum registo foi importado.",
        "error_row": "Linha {row}"
      },
      "labels": {
        "freeze_columns": "Congelar colunas",
        "freeze_rows": "Congelar linhas",
        "gridlines": "Linhas de grade",
        "size": "Tamanho",
        "sticky_headers": "Cabeçalhos fixos",
        "striped_rows": "Linhas listradas",
        "toggle_columns": "Alternar colunas",
        "group_by": "Agrupar por"
      }
    }
  }
}
